import { StringIdentifierSerializer } from './string-identifier-serializer';

export function stringIdentifierNumberSerializer<ExtendedType extends number = number>(
    extraConversion?: (parsed: number) => ExtendedType,
): StringIdentifierSerializer<ExtendedType> {
    return {
        deserialize(stringVal) {
            const parsed = parseInt(stringVal, 10);
            if (extraConversion) {
                return extraConversion(parsed);
            }
            return parsed as ExtendedType;
        },
        serialize(val) {
            return val.toString();
        },
    };
}
